import '../../../common/dashboard/filters/filter.js.coffee'

Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.FixedStringAttributeFilter extends Common.Dashboard.Filters.Filter
  @FILTER_TYPE: 'fixed_string'
  removable: true

  constructor: ({attribute, values}) ->
    @attribute = attribute
    @values = values

  getCode: ->
    @attribute.get('code')

  getFilterType: ->
    CustomerVisualMode.Filters.FixedStringAttributeFilter.FILTER_TYPE

  getName: ->
    @attribute.get('name')

  translatedFilterType: ->
    @getName()

  getAttribute: ->
    @attribute

  getValues: ->
    @values.map (value) -> name: value
